import { Component } from 'react';
import lodash from 'lodash';

import ComplionToolbar from './ComplionToolbar';

export class ToolbarPluginButton {
    constructor({
        Component,
        key,
        group
    }) {
        this.Component = Component;
        this.key = key;
        this.group = group;
    }
}

export function complionToolbarPlugin({
    toolbarItems
}) {
    class ToolbarHost extends Component {
        constructor(...args) {
            super(...args);
            this.state = { pluginFunctions: null, initialized: false };
        }

        componentDidMount() {
            this.handleRefresh();
        }

        handleRefresh() {
            this.props.onInitialized().then(({ pluginFunctions }) => {
                this.setState({ pluginFunctions, initialized: true });
            });
        }

        render() {
            if (!this.state.initialized) {
                return null;
            }
            return (
                <ComplionToolbar>
                    { this.renderToolbarItems() }
                </ComplionToolbar>
            );
        }

        renderToolbarItems() {
            const { pluginFunctions } = this.state;
            const { editorState } = this.props;
            return lodash.map(toolbarItems, (item, index) => {
                const { key, group, Component: ToolbarItem } = item;
                return <ToolbarItem key={key || index} group={group} editorState={editorState} {...pluginFunctions} />;
            });
        }
    }

    class ToolbarPlugin {
        constructor() {
            this.onInitializePromise = new Promise(resolve => {
                this.onInitialize = resolve;
            });
        }

        initialize(pluginFunctions) {
            this.pluginFunctions = pluginFunctions;
            this.onInitialize({ pluginFunctions });
        }

        onInitialized() {
            return this.onInitializePromise;
        }

        get ToolbarHost() {
            return ({ editorState, readOnly }) => {
                if (readOnly) {
                    return null;
                }
                return <ToolbarHost editorState={editorState}
                    onInitialized={this.onInitialized.bind(this)}/>;
            };
        }
    }

    return new ToolbarPlugin();
}

